import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const Component = ({title, value}) => {
    return (
        <TableRow>
            <TableCell className="highlight">{title}</TableCell><TableCell>{value}</TableCell>
        </TableRow>
    );
};

Component.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default Component;
